<script lang="ts">
  import type { Embed } from '../types';

  export let data: Embed;
</script>

<figure class="h-auto w-full">
  <iframe
    src="{data.embed}"
    class="aspect-video h-full w-full"
    loading="lazy"
    title="{data.caption || null}"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>

  {#if data.caption}
    <figcaption class="text-default-500 dark:text-dark-800 mb-4 mt-3 text-center text-xs">
      <!-- eslint-disable-next-line -->
      {@html data.caption}
    </figcaption>
  {/if}
</figure>
